import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "The perfect woman [nsfw]",
  "description": "",
  "published": "2009-11-24T00:00:00.000Z",
  "redirect_from": ["/blog/the-perfect-woman-nsfw/swizec/901"],
  "categories": "Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`This is just a little something I found on a certain internet message board yesterday, but I really think it encompasses what a woman should do to have a perfectly happy man.`}</p>
    <p>{`Not only is she baking me cake, she's doing it in the nude! Win!!`}</p>
    <p><a parentName="p" {...{
        "href": "http://swizec.com/blog/wp-content/uploads/2009/11/1259019730277.jpg"
      }}><img parentName="a" {...{
          "src": "https://swizec.com/blog/wp-content/uploads/2009/11/1259019730277.jpg",
          "alt": "1259019730277",
          "title": "1259019730277"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      